/**
 * クラス名：装置設定の溶接難易度画面
 * 作成者：チュー
 * 作成日：2023/06/01
 * バージョン：1.0
 */

import React, { useState, useEffect, forwardRef, useRef } from 'react';
import { Row, Col, Input, Button, Space, Popover } from 'antd';
import { PlusCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Table } from 'react-bootstrap';
import { isEmpty } from '@rc-component/mini-decimal/es/numberUtil';
import { commonModal } from '../../../common/CommonModal';
import {
  MaterialCategories,
  getInputBorderStyle,
  handleKeyPress,
  isDigitZenkaku,
  regexExp,
  sortListByMasterData,
  toHalfWidth,
  updateList,
} from '../../../common/Common';

const YousetsuDifficulty = forwardRef((props, ref) => {
  const [editMode, setEditMode] = useState(false);
  const [isItaatsu, setIsItaatsu] = useState(false);

  const [detailsItaatsu, setDetailsItaatsu] = useState([]);
  const [detailsItaatsuTemp, setDetailsItaatsuTemp] = useState([]);
  const [list, setList] = useState([]);

  const [materialType, setMaterialType] = useState([]);

  const [filterKeys, setFilterKeys] = useState([]);

  const [errIndexVal, setErrIndexVal] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');
  const inputRef = useRef([]);
  useEffect(() => {
    setErrIndexVal([]);
    setErrorMessage('');
    setEditMode(props.editMode);
    setDetailsItaatsu(props.detailsData?.weldDifficultyCoeffThMaster);
    setDetailsItaatsuTemp(props.detailsData?.weldDifficultyCoeffThMaster);
    setList(props.detailsData?.weldDifficultyCoeffThItems);
    setMaterialType(props.materialTypes);
    const usedItems = props.materialTypes?.filter((item) => item.info.isUsed);

    // Extract the id values from the filtered items
    const usedIds = usedItems?.map((item) => item.id);
    setFilterKeys(usedIds);
  }, [props.detailsData, props.editMode, props.materialTypes]);
  const thickness = () => {
    setIsItaatsu(true);
  };
  const addThicknessModalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>板厚</p>
    </div>
  );
  const addData = () => {
    setIsUpdateData(true);
  };

  const addItaatsu = (id, index) => {
    inputRef.current[index].focus();
    const copyData = detailsItaatsuTemp.slice(); // Create a copy of the original array

    const insertIndex = detailsItaatsuTemp?.findIndex((item) => item.no === id); // Find the index of the item with id 2

    if (insertIndex !== -1) {
      const data = {
        no: detailsItaatsuTemp?.length + 1,
        value: 0,
        isOutOfRange: false,
      };
      copyData.splice(insertIndex + 1, 0, data); // Insert the new object after the found index
      setDetailsItaatsuTemp(copyData);
    }
  };
  const deleteItaatsu = (id, e, index) => {
    // 更新するエラーインデックスを得る
    const updatedErrorIndexes = errIndexVal?.filter((item) => item !== index);

    const finalErrorIndexes = updatedErrorIndexes?.map((item) => (item > index ? item - 1 : item));
    setErrIndexVal(finalErrorIndexes);
    if (detailsItaatsuTemp?.filter((item) => item.isOutOfRange === false)?.length > 2) {
      const updatedData = detailsItaatsuTemp?.map((row) => {
        if (row.no === id) {
          return { ...row, isOutOfRange: true };
        }
        return row;
      });
      setDetailsItaatsuTemp(updatedData);
      const filterData = updatedData?.filter((i) => !i.isOutOfRange);
      if (index + 1 !== filterData?.length) {
        inputRef.current[index].focus();
      }
    }
  };
  const closeAddModal = () => {
    if (isItaatsu === true) {
      setIsItaatsu(false);
      setDetailsItaatsuTemp(detailsItaatsu);
    }
  };
  const cancelAddModal = () => {
    setErrIndexVal([]);
    setErrorMessage('');
    setIsItaatsu(false);
    setDetailsItaatsuTemp(detailsItaatsu);
  };
  const handleItaatsuChange = (event, id, field) => {
    if (regexExp.test(event.target.value) && !isDigitZenkaku(event.target.value)) return;
    const updatedData = detailsItaatsuTemp?.map((row) => {
      if (row.no === id) {
        return { ...row, [field]: event.target.value };
      }
      return row;
    });
    setDetailsItaatsuTemp(updatedData);
  };

  const addItaatsuMaster = () => {
    const deletedId = [];

    detailsItaatsu?.forEach((item1, index) => {
      const found = detailsItaatsuTemp?.find((item2) => item2.no === item1.no && item2.isOutOfRange === true);
      if (found) {
        deletedId.push(item1.no);
      }
    });

    const newId = detailsItaatsuTemp
      ?.filter((item) => !item.isOutOfRange && !detailsItaatsu.some((data2Item) => data2Item.no === item.no))
      ?.map((item) => item.no);

    const updatedData = updateList(list, deletedId, newId);

    const sortYousetsuList = sortListByMasterData(updatedData, detailsItaatsuTemp);

    setIsItaatsu(false);
    setDetailsItaatsu(detailsItaatsuTemp);
    props.updatedItaatsu(detailsItaatsuTemp);

    setList(sortYousetsuList);
    props.updatedListData(sortYousetsuList);
  };
  const isValueOrderCorrect = (e, no, field) => {
    const temp = detailsItaatsuTemp?.filter((i) => i.isOutOfRange === false);

    const insertIndex = temp?.findIndex((item) => item.no === no);
    if (regexExp.test(temp[insertIndex].value) && !isDigitZenkaku(temp[insertIndex].value)) return;
    // IQX_WEBEST-220の対応-START
    if (regexExp.test(temp[insertIndex].value)) {
      // 全角の場合、
      temp[insertIndex].value = toHalfWidth(temp[insertIndex].value); // 半角へ変換
      e.target.value = temp[insertIndex].value;
      handleItaatsuChange(e, no, field);
    }
    if (isNaN(parseFloat(temp[insertIndex].value))) {
      setErrIndexVal([...errIndexVal, insertIndex]);
      setErrorMessage('数字値を入力してください！');
      return;
    }
    // IQX_WEBEST-220の対応-END

    if (insertIndex > 0) {
      const prevValue = parseFloat(temp[insertIndex - 1].value);
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);
      if (currentValue > prevValue && currentValue < nextValue) {
        let temp = [insertIndex - 1, insertIndex, insertIndex + 1];

        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex && item != insertIndex - 1));

        setErrorMessage('前のしきい値より大きい値を入力してください！');
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);

        if (currentValue <= prevValue) {
          setErrorMessage('前のしきい値より大きい値を入力してください！');
        } else if (currentValue >= nextValue) {
          setErrorMessage('次のしきい値より小さい値を入力してください！');
        }
      }
    } else {
      const currentValue = parseFloat(temp[insertIndex].value);
      const nextValue = parseFloat(temp[insertIndex + 1].value);

      if (currentValue < nextValue) {
        setErrIndexVal(errIndexVal?.filter((item) => item !== insertIndex));
      } else {
        setErrIndexVal([...errIndexVal, insertIndex]);
        setErrorMessage('次のしきい値より小さい値を入力してください！');
      }
    }
  };
  const addItaatsuContent = (
    <>
      <div style={{ height: 400, overflow: 'auto' }}>
        <Row className="chargeAmount registerModal">
          <Col style={{ width: '100%' }}>
            <Table className="master-table">
              <thead>
                <tr style={{ textAlign: 'center' }}>
                  <th style={{ width: '20%' }} className="param-tbl-header">
                    No
                  </th>

                  <th style={{ width: '60%' }} className="param-tbl-header">
                    <Space>
                      <label>しきい値</label>（≦）
                    </Space>
                  </th>
                </tr>
              </thead>
              <tbody>
                {detailsItaatsuTemp
                  ?.filter((i) => i.isOutOfRange === false)
                  ?.map((item, index) => (
                    <tr key={index} style={{ textAlign: 'center' }}>
                      <td>{index + 1}</td>

                      <td>
                        {errIndexVal?.includes(index) ? (
                          <Popover
                            content={<div style={{ padding: 7 }}>{errorMessage}</div>}
                            placement="left"
                            visible={true}
                          ></Popover>
                        ) : (
                          ''
                        )}
                        <Input
                          value={item.value}
                          onChange={(e) => handleItaatsuChange(e, item.no, 'value')}
                          onBlur={(e) => isValueOrderCorrect(e, item.no, 'value')}
                          onPressEnter={(e) => isValueOrderCorrect(e, item.no, 'value')}
                          className={errIndexVal?.includes(index) ? 'red-border' : ''}
                          style={{
                            ...getInputBorderStyle(index, detailsItaatsuTemp),
                            pointerEvents: editMode ? 'auto' : 'none',
                          }}
                          onKeyPress={(e) => {
                            handleKeyPress(e, false);
                          }}
                          ref={(ref) => (inputRef.current[index] = ref)}
                        ></Input>
                      </td>
                      <td
                        style={{ border: 'none', backgroundColor: 'white', verticalAlign: 'middle', width: '20%' }}
                        className="min"
                      >
                        <Row justify="center">
                          <PlusCircleFilled
                            onClick={() => addItaatsu(item.no, index + 1)}
                            className="add-remove-icon"
                            style={{ marginLeft: 5, marginRight: 5, pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                          <CloseCircleFilled
                            className="add-remove-icon"
                            onClick={(e) => deleteItaatsu(item.no, e, index)}
                            style={{ pointerEvents: editMode ? 'auto' : 'none' }}
                          />
                        </Row>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
      <Row justify="center" className="mt-2">
        <Button
          className={isEmpty(errIndexVal) ? 'mainButton' : 'disabledButton'}
          id="update"
          onClick={addItaatsuMaster}
        >
          OK
        </Button>
        <Button className="cancelButton" style={{ marginLeft: 10 }} id="discard" onClick={cancelAddModal}>
          キャンセル
        </Button>
      </Row>
    </>
  );

  const listDataChange = (event, key, no) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    const newList = { ...list };
    const itemIndex = newList[key]?.findIndex((item) => item.no === no);

    if (itemIndex !== -1) {
      newList[key][itemIndex].value = event;
      setList(newList);
      props.updatedListData(newList);
    }
  };

  const listDataChangeBlur = (event, key, no) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    const newList = { ...list };
    const itemIndex = newList[key]?.findIndex((item) => item.no === no);

    if (itemIndex !== -1) {
      event = regexExp.test(event) ? toHalfWidth(event) : event;
      // newList[key][itemIndex].value = parseInt(event) || 0;
      newList[key][itemIndex].value = Number(event) || 0; // 2025-02-14 修正案(eventをparseIntするとIntigerになって、入力値が小数点の場合、小数点値が亡くなったのでNumberに修正)
      setList(newList);
      props.updatedListData(newList);
    }
  };

  return (
    <>
      <div className="table-container" style={{ marginLeft: 10, marginRight: 10 }}>
        <Table
          style={{
            width:
              detailsItaatsu?.filter((i) => i.isOutOfRange === false)?.length > 8
                ? '100%'
                : detailsItaatsu?.filter((i) => i.isOutOfRange === false)?.length * 98 + 196 + 'px',
          }}
        >
          <tr style={{ textAlign: 'center' }}>
            <td style={{ width: '196px' }} className="param-tbl-header fixedCol">
              <Row justify="center" className="ant-row-no-bg-color">
                <Space>
                  材質区分 /
                  {editMode ? (
                    <>
                      <Button className="cancleButton" onClick={thickness} style={{ pointerEvents: 'auto' }}>
                        板厚
                      </Button>
                    </>
                  ) : (
                    <>
                      <label>板厚</label>
                    </>
                  )}
                </Space>
              </Row>
            </td>

            {detailsItaatsu
              ?.filter((i) => i.isOutOfRange === false)
              ?.map((item, index) => (
                <td key={index} style={{ width: '98px' }} className="param-tbl-header">
                  ～{item.value}t
                </td>
              ))}
          </tr>
          {Object.keys(list)
            ?.filter((listkey) => filterKeys?.includes(parseInt(listkey)))
            ?.map((key) => (
              <tr key={key} style={{ textAlign: 'center' }}>
                <td style={{ color: 'white', width: '196px' }} className="param-tbl-header fixedCol">
                  {materialType?.find((item) => item.id.toString() === key)?.name}
                </td>
                {list[key]?.map((item, index) => (
                  <td key={index} style={{ verticalAlign: 'middle', textAlign: 'center', width: 210 }}>
                    <Input
                      value={item.value}
                      onChange={(e) => listDataChange(e.target.value, key, item.no)}
                      onBlur={(e) => listDataChangeBlur(e.target.value, key, item.no)}
                      onPressEnter={(e) => listDataChangeBlur(e.target.value, key, item.no)}
                      onKeyPress={(e) => {
                        handleKeyPress(e, false);
                      }}
                      style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                      className={editMode ? 'input-editable ' : 'input-non-editable'}
                    />
                  </td>
                ))}
              </tr>
            ))}
        </Table>
      </div>

      {/* 板厚 */}
      {isItaatsu
        ? commonModal(
            isItaatsu,
            addThicknessModalTitle,
            null,
            null,
            400,
            addData,
            closeAddModal,
            addItaatsuContent,
            null,
            null,
            true
          )
        : ''}
    </>
  );
});

export default YousetsuDifficulty;
